import React, { useState } from "react";
import { Tabs } from "antd";

import AllPayments from "./AllPayments";
import DeliveryPayments from "./DeliveryPayments";

export default function Payments() {
  const [activeKey, setActiveKey] = useState("1");

  const handleTabChange = (key) => {
    setActiveKey(key);
  };

  return (
    <div className="card-container">
      <Tabs
        type="card"
        activeKey={activeKey}
        onChange={handleTabChange}
        destroyInactiveTabPane={true}
      >
        <Tabs.TabPane tab="Payments" key="1">
          <AllPayments />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Delivery Payments" key="2">
          <DeliveryPayments />
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
}
